import { HttpContextToken } from '@angular/common/http';

export interface ErrorResponseWithStatus {
  message: string;
  status: number;
}

export const PASS_STATUS_CODE = new HttpContextToken(() => false);
